// Front page hero: fading premium slider (4 × 4:5 portrait slides) with autoplay (5s), dots, prev/next and touch swipe.
// Markup: [data-hero] > [data-hero-slide]* + [data-hero-dot]* + [data-hero-prev]/[data-hero-next]. Autoplay pauses on
// hover/focus, hidden tabs and prefers-reduced-motion.
// Analytics: slides of promoted (featured) events carry data-kt-promo="{id}" → promo_view once per event when shown.
// Performance (1.9.6): slides 2–4 are rendered `hidden` (display:none → their lazy images are not fetched while the page
// loads) and unhidden after window load, or right before they are shown.
import { qs, qsa } from './dom.js';

export function initHero() {
  qsa('[data-hero]').forEach((hero) => {
    const slides = qsa('[data-hero-slide]', hero);
    const dots = qsa('[data-hero-dot]', hero);
    const seen = {};
    const promo = (s) => {
      const id = s && s.dataset.ktPromo;
      if (id && !seen[id]) { seen[id] = 1; window.ktTrack?.('promo_view', '', { id: Number(id) }); }
    };
    const reveal = () => slides.forEach((s) => { s.hidden = false; });
    if (slides.length < 2) { reveal(); promo(slides[0]); return; }
    if (document.readyState === 'complete') reveal();
    else window.addEventListener('load', reveal, { once: true });
    let active = 0;
    let timer = null;
    let startX = 0;

    function show(i) {
      active = (i + slides.length) % slides.length;
      slides[active].hidden = false;
      slides.forEach((s, idx) => {
        const on = idx === active;
        s.classList.toggle('opacity-100', on);
        s.classList.toggle('opacity-0', !on);
        s.classList.toggle('pointer-events-none', !on);
        s.setAttribute('aria-hidden', String(!on));
      });
      promo(slides[active]);
      dots.forEach((d, idx) => {
        const on = idx === active;
        d.classList.toggle('bg-raspberry', on);
        d.classList.toggle('w-8', on);
        d.classList.toggle('bg-white/50', !on);
        d.classList.toggle('w-2', !on);
        d.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function restart() {
      clearInterval(timer);
      if (!reduced) timer = setInterval(() => show(active + 1), 5000);
    }

    dots.forEach((d, idx) => d.addEventListener('click', (e) => { e.stopPropagation(); show(idx); restart(); }));
    const prev = qs('[data-hero-prev]', hero);
    const next = qs('[data-hero-next]', hero);
    if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); show(active - 1); restart(); });
    if (next) next.addEventListener('click', (e) => { e.stopPropagation(); show(active + 1); restart(); });
    hero.addEventListener('focusin', () => clearInterval(timer));
    hero.addEventListener('focusout', restart);
    hero.addEventListener('touchstart', (e) => { startX = e.changedTouches[0].screenX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].screenX - startX;
      if (dx < -50) { show(active + 1); restart(); }
      if (dx > 50) { show(active - 1); restart(); }
    }, { passive: true });
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', restart);
    document.addEventListener('visibilitychange', () => { document.hidden ? clearInterval(timer) : restart(); });

    show(0);
    restart();
  });
}
